// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';

// 导入视图组件
import HomePage from '../views/HomePage.vue';
import AboutUsPage from '../views/AboutUsPage.vue';
import MajorMediaPage from '../views/MajorMediaPage.vue'; 
import NetworkAlliancePage from '../views/NetworkAlliancePage.vue'; 
import AccountServicePage from '../views/AccountServicePage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'HomePage', // 首页，对应 AppHeader 中的 "Products" / "产品中心" 链接
    component: HomePage
  },
  {
    path: '/about',
    name: 'AboutUsPage', // 关于我们页面
    component: AboutUsPage
  },
  {
    path: '/major-media-services', // "网盟服务" 页面，对应 AppHeader 中的 "Solutions" / "网盟服务" 链接
    name: 'NetworkAlliancePage',
    component: NetworkAlliancePage
  },
  {
    path: '/major-media', // "大媒体服务" 页面（如果这个页面内容和网盟服务不同）
    name: 'MajorMediaPage',   // 这个路由名是 MajorMediaPage
    component: MajorMediaPage
  },
  { 
    path: '/account-service', 
    name: 'AccountServicePage',  
    component: AccountServicePage
  }
];

const router = new VueRouter({
  mode: 'history', // 使用 history 模式，URL 更美观
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // 目标带有哈希值 (例如 /#sectionId 或 /some-page#sectionId)
      return new Promise((resolve) => {
        // 等待DOM更新，确保元素存在
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            resolve({
              selector: to.hash,
              behavior: 'smooth',
              // 你可以根据固定头部的高度添加偏移量
              // offset: { y: 70 } // 例如，如果你的固定头部高度是70px
            });
          } else {
            // 如果找不到元素，滚动到页面顶部
            resolve({ x: 0, y: 0 });
          }
        }, 300); // 延迟时间可以根据需要调整
      });
    } else if (savedPosition) {
      // 如果有保存的滚动位置 (例如通过浏览器前进/后退按钮)
      return savedPosition;
    } else {
      // 对于所有其他导航，滚动到页面顶部
      return { x: 0, y: 0 };
    }
  }
});

export default router;